import Vue from 'vue'
import { USER_INFO } from "@/store/mutation-types"
const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => { state.user.avatar = Vue.ls.get(USER_INFO).avatar; return state.user.avatar },
  username: state => state.user.username,
  nickname: state => { state.user.realname = Vue.ls.get(USER_INFO).realname; return state.user.realname },
  welcome: state => state.user.welcome,
  permissionList: state => state.user.permissionList,
  userInfo: state => { state.user.info = Vue.ls.get(USER_INFO); return state.user.info },
  addRouters: state => state.permission.addRouters,
  async servicePhone(state) {
    if (!state.CustomerServicePhone || state.CustomerServicePhone.length <= 0) {
      const res = await Vue.getAction('/api_admin/GlobalConfig/DetailByKey', { key: 'CustomerServicePhone' });
      if (res.IsSuccess) {
        state.CustomerServicePhone = res.Data.GlobalConfigValue;
      }
    }
    return state.CustomerServicePhone;
  },
  BuyCarToConfirmData: state => {
    return JSON.parse(window.localStorage.getItem('BuyCarToConfirmData'));
    //return state.BuyCarToConfirmData;
  },
  ConfirmToPayData: state => {
    return JSON.parse(window.localStorage.getItem('ConfirmToPayData'));
    //return state.BuyCarToConfirmData;
  }
}

export default getters